export const MAP_DESTINATION_TO_PRODUCT = 'MAP_DESTINATION_TO_PRODUCT';
export const UPDATE_PRODUCT_DESTINATION = 'UPDATE_PRODUCT_DESTINATION';
export const UPDATE_PRODUCT_LOCATION = 'UPDATE_PRODUCT_LOCATION';
export const SAVE_PRODUCT_LOCATION = 'SAVE_PRODUCT_LOCATION';
export const SAVE_PRODUCT_LOCATION_SUCCEEDED = 'SAVE_PRODUCT_LOCATION_SUCCEEDED';
export const UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED = 'UPDATE_MULTI_PRODUCT_LOCATION_REQUESTED';
export const UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED = 'UPDATE_MULTI_PRODUCT_LOCATION_SUCCEEDED';
export const DETECT_TYPE_OF_CODE_REQUESTED = 'DETECT_TYPE_OF_CODE_REQUESTED';
export const DETECT_TYPE_OF_CODE_SUCCESSED = 'DETECT_TYPE_OF_CODE_SUCCESSED';
export const SKIP_DISPUTE_ITEM = 'SKIP_DISPUTE_ITEM';
